// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../add/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var add = convertToFP(fn, 2);
export default add;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/add/index.js
// module id = 808
// module chunks = 0